import React from "react";
import { ProgressBar } from "primereact/progressbar";
import PropTypes from "prop-types";
import "./conversations.scss";
import AttachmentIcon from "./AttachmentIcon";
import CustomeButton from "../../Button";
import ErrorMessage from "./ErrorMessage";
import { FileUpload } from "primereact/fileupload";
import { openFileInNewTab } from "~/utils/fileUtils";
import DocumentDescription from "~/components/document-description";
import { useParams } from "react-router-dom";

const Attachments = ({
  file,
  fileHandler,
  progressBar,
  icon,
  error = false,
  handleErrorVisibility = () => {},
  getFileSizeMB = () => {},
  handleReplace = () => {},
  showPreviewIcon = true,
  showDescriptionIcon = false,
  id,
  relatedType = "",
}) => {
  return (
    <div className="attachment">
      <div
        className={`attachment__file ${showPreviewIcon ? "gap-3 pr-4" : ""}`}
      >
        <div className="file-content">
          <div className="icon-container">
            <AttachmentIcon file={file} />
          </div>
          <div className="file-details">
            <p
              className={`file-name ${showPreviewIcon ? "file-name-link" : ""}`}
              onClick={() => {
                showPreviewIcon && openFileInNewTab(file);
              }}
            >{`${file?.fileName || file?.name}`}</p>
            <div></div>
            {progressBar && (
              <ProgressBar
                value={40}
                mode="indeterminate"
                color="#188A42"
                showValue={false}
              ></ProgressBar>
            )}
          </div>
        </div>
        {error.state && (
          <div className="attachment__file--actions">
            <CustomeButton
              label="Remove"
              variant="remove"
              className="access-btn"
              onClick={fileHandler}
            />
            {getFileSizeMB(file) < 20 && (
              <div className="replase__btn">
                <FileUpload
                  name="replace-file"
                  customUpload={true}
                  onSelect={(newFile) => handleReplace(newFile, file)}
                  chooseOptions={{
                    label: "Replace",
                    className: "attachment-button  p-button-outlined ",
                  }}
                  mode="advanced"
                />
              </div>
            )}
          </div>
        )}
        {!error.state && (
          <div className="flex align-items-center justify-content-center gap-2 ml-2">
            {showDescriptionIcon && (
              <DocumentDescription data={file} id={id} type={relatedType} />
            )}
            {showPreviewIcon && (
              <i
                className={`pi pi-external-link action-icon`}
                onClick={() => openFileInNewTab(file)}
              />
            )}
            <i className={`pi ${icon} action-icon`} onClick={fileHandler} />
          </div>
        )}
      </div>
      {error.visible && error.state && (
        <ErrorMessage
          summary={
            getFileSizeMB(file) > 20
              ? "File Exceeds Size Limit"
              : "Unsupported File"
          }
          detail={
            getFileSizeMB(file) > 20
              ? "This file exceeds the maximum size limit. Please upload a smaller file"
              : "This file type is not supported. Please upload a valid file format."
          }
          handleClose={handleErrorVisibility}
        />
      )}
    </div>
  );
};

Attachments.propTypes = {
  file: PropTypes.file,
  fileHandler: PropTypes.func,
  progressBar: PropTypes.bool,
  icon: PropTypes.string,
  error: PropTypes.bool,
  handleErrorVisibility: PropTypes.func,
  getFileSizeMB: PropTypes.func,
  showerror: PropTypes.bool,
  showPreviewIcon: PropTypes.bool,
};

export default Attachments;
